import { createAction } from 'redux-actions';
import axios from 'axios';
import AuthService from '../../services/AuthService';

export const PRE_CHECK_USER_PENDING = createAction('PRE_CHECK_USER_PENDING');
export const PRE_CHECK_USER_DOESNT_EXISTS = createAction('PRE_CHECK_USER_DOESNT_EXISTS');
export const PRE_CHECK_USER_NOT_ACTIVATED = createAction('PRE_CHECK_USER_NOT_ACTIVATED');
export const PRE_CHECK_USER_SUCCESS = createAction('PRE_CHECK_USER_SUCCESS');
export const PRE_CHECK_USER_ERROR = createAction('PRE_CHECK_USER_ERROR');


export const hanglePreCheck = (username, history) => {
  return async (dispatch, getState) => {
      const cancelToken = axios.CancelToken.source();
      dispatch(PRE_CHECK_USER_PENDING(cancelToken));
      try{
          const result = await AuthService.preCheck(username);   
          const statusCode = result.status;

          if (statusCode === 200){
            const data = result.data;
            const preCheckData = {
              university: data.universities && data.universities.length > 0 ? data.universities[0] : null,
              username: username
            };
            dispatch(PRE_CHECK_USER_SUCCESS(preCheckData));
            history.push('/auth/login/');
          }else if (statusCode === 202) {
            dispatch(PRE_CHECK_USER_NOT_ACTIVATED("User not activated."));
          }          
      }catch (error) {
        const statusCode = error.response ? error.response.status : 0;
        if (statusCode === 404) {
          dispatch(PRE_CHECK_USER_DOESNT_EXISTS("User doesn't exist."));
        }else{
          dispatch(PRE_CHECK_USER_ERROR("Try again later."));            
          console.log(error);
        }          
      }
  };
};
